window.deadzone = .04

function axesDeadzone(axes) {
    if (Math.abs(axes) < deadzone) {
        return 0
    } else {
        return axes
    }
}

function gamepadMaker(gamepad) {
    return {
        setJoystickDeadzone(deadzone) { window.deadzone = deadzone },
        a: gamepad.buttons[0].pressed,
        b: gamepad.buttons[1].pressed,
        x: gamepad.buttons[2].pressed,
        y: gamepad.buttons[3].pressed,
        dpad_down: gamepad.buttons[13].pressed,
        dpad_up: gamepad.buttons[12].pressed,
        dpad_left: gamepad.buttons[14].pressed,
        dpad_right: gamepad.buttons[15].pressed,
        left_bumper: gamepad.buttons[4].pressed,
        right_bumper: gamepad.buttons[5].pressed,
        left_stick_button: gamepad.buttons[10].pressed,
        right_stick_button: gamepad.buttons[11].pressed,
        back: gamepad.buttons[8].pressed,
        start: gamepad.buttons[9].pressed,
        guide: false,
        left_stick_x: axesDeadzone(gamepad.axes[0]),
        left_stick_y: axesDeadzone(-gamepad.axes[1]),
        right_stick_x: axesDeadzone(gamepad.axes[2]),
        right_stick_y: axesDeadzone(-gamepad.axes[3]),
        right_trigger: gamepad.buttons[7].value,
        left_trigger: gamepad.buttons[6].value,
    }
}

function ffF310gamepadMaker(gamepad) {
    return {
        setJoystickDeadzone(deadzone) { window.deadzone = deadzone },
        a: gamepad.buttons[0].pressed,
        b: gamepad.buttons[1].pressed,
        x: gamepad.buttons[2].pressed,
        y: gamepad.buttons[3].pressed,
        dpad_down: gamepad.axes[7] == 1,
        dpad_up: gamepad.axes[7] == -1,
        dpad_left: gamepad.axes[6] == -1,
        dpad_right: gamepad.axes[6] == 1,
        left_bumper: gamepad.buttons[4].pressed,
        right_bumper: gamepad.buttons[5].pressed,
        left_stick_button: gamepad.buttons[9].pressed,
        right_stick_button: gamepad.buttons[10].pressed,
        back: gamepad.buttons[6].pressed,
        guide: false,
        start: gamepad.buttons[7].pressed,
        left_stick_x: axesDeadzone(gamepad.axes[0]),
        left_stick_y: axesDeadzone(-gamepad.axes[1]),
        right_stick_x: axesDeadzone(gamepad.axes[3]),
        right_stick_y: axesDeadzone(-gamepad.axes[4]),
        right_trigger: axesDeadzone(gamepad.axes[5]),
        left_trigger: axesDeadzone(gamepad.axes[2]),
    }
}

function emptyGamepadMaker() {
    return {
        setJoystickDeadzone(deadzone) { window.deadzone = deadzone },
        a: false,
        b: false,
        x: false,
        y: false,
        dpad_down: false,
        dpad_up: false,
        dpad_left: false,
        dpad_right: false,
        left_bumper: false,
        right_bumper: false,
        left_stick_button: false,
        right_stick_button: false,
        back: false,
        start: false,
        guide: false,
        left_stick_x: 0,
        left_stick_y: 0,
        right_stick_x: 0,
        right_stick_y: 0,
        right_trigger: 0,
        left_trigger: 0
    }
}

export { emptyGamepadMaker, ffF310gamepadMaker, gamepadMaker }


//////////////////
// WEBPACK FOOTER
// ./src/gamepads.js
// module id = 24
// module chunks = 0